module.exports = __webpack_public_path__ + "static/media/Roboto-Black.301fe70f.ttf";